<ng-container *transloco="let t">
  <app-strategy-overlay>
    @if (strategy) {
      <app-strategy-page [campaignType]="CampaignType.SP" [strategy]="strategy">
        <app-strategy-asins withAsins [strategy]="strategy" [isReadOnly]="isReadOnly" />

        <div withTargetingStats class="mt-6">
          <app-targeting-asin-stats [isReadOnly]="isReadOnly" [strategy]="strategy"></app-targeting-asin-stats>
        </div>
      </app-strategy-page>
    }
  </app-strategy-overlay>
</ng-container>
